<template>
  <div id="app">
    <div class="container-fluid">
      <nav
        class="navbar fixed-top"
        style="background-color: #1f2122; justify-content: left"
      >
        <h1
          style="
            font-family: 'Anton', sans-serif;
            color: white;
            font-size: 48px;
            margin: 0;
            display: inline;
          "
        >
          <router-link
            to="/"
            style="
              font-family: 'Anton', sans-serif;
              color: #e0e0e0;
              font-size: 48px;
              text-decoration: none;
              cursor: pointer;
            "
          >
            JOSH CURTIS
          </router-link>
        </h1>
        <h2
          style="
            font-family: 'Anton', sans-serif;
            color: #888888;
            padding-left: 20px;
          "
        >
          HUSBAND, <router-link to="/work" style="color: #aaaaaa; text-decoration: none;">CODER</router-link>, ADVENTURER, <router-link to="/music" style="color: #aaaaaa; text-decoration: none;">MUSICIAN</router-link>, MOTORCYCLIST, <a href="https://cowboycojewelry.com/" target="_blank" rel="noopener" style="color: #aaaaaa; text-decoration: none;">CREATOR</a>
        </h2>
      </nav>
      <router-view />
    </div>
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #d1d9e0;
  background-color: #1f2122;
}

a,
a:visited,
a:hover,
a:active {
  text-decoration: none;
  color: inherit;
}

.router-link-active,
.router-link-exact-active {
  text-decoration: none;
  color: inherit;
}
</style>

<script>
export default {
  name: "App",
};
</script>
